import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';
import { Logger } from '../../../../common/core/utilities/logging/logger';

@Component({
  selector: 'app-loading-shimmer',
  standalone: true,
  imports: [SkeletonModule],
  templateUrl: './loading-shimmer.component.html',
  styleUrl: './loading-shimmer.component.scss',
})
export class LoadingShimmerComponent implements OnChanges {
  @Input() type: string = 'form'; // Default value

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['type']) {
      Logger.debug('Type changed to:', this.type);
      this.handleTypeChange(this.type);
    }
  }

  private handleTypeChange(type: string): void {
    // Logic to handle different types (e.g., table, form, etc.)
    Logger.debug('Handling type:', type);
  }
}
